import { Directive, EventEmitter, Input, Output } from '@angular/core';

import {
  ImmomioIconName,
  ITicketResidentOverview,
  ITicketResidentOverviewEdge,
  ITicketResidentOverviewHQ,
} from '../../../models';
import { IActionState } from '../../../utils';

@Directive()
export abstract class TicketsBaseComponent {
  @Input() tickets: ITicketResidentOverviewEdge[] = [];
  @Input() ticketsActionState: IActionState;
  @Input() hasNextPage: boolean;
  @Input() isArchiving = false;
  @Output() openTicket: EventEmitter<ITicketResidentOverview> = new EventEmitter();
  @Output() loadMoreTickets: EventEmitter<void> = new EventEmitter();
  @Output() archiveTicket = new EventEmitter<ITicketResidentOverview | ITicketResidentOverviewHQ>();
  @Input() txtLoadMore = '';
  @Input() txtNoTickets = '';
  public immomioIconName = ImmomioIconName;
}
